import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdiantamentoListarComponent } from './adiantamento-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: AdiantamentoListarComponent}
  ])],
  exports: [RouterModule]
})
export class AdiantamentoListarRoutingModule { }
